import React, { useEffect, useRef } from "react";
import { assignmentStatus } from "../../components/constants/constants";
import { useMobileView } from "./MobileViewContext";
import SpeakFooter from "../speak_test/SpeakFooter";
import {isSPEAKABC} from "../../libs/env";
const SpeakQuestionInfo = ({
  data,
  assessmentStarted,
  section,
  setShowAssessmentInfo,
  hasUserInteracted,
}) => {
  let {isMobileView} = useMobileView();
  const SectionaudioRef = useRef(null);
  const playaudio = async () => {
    if (SectionaudioRef.current) {
      try {
        await SectionaudioRef.current.play();
        SectionaudioRef.current.onended = () => {
          localStorage.setItem(
            `ShowInfo${data.student_assessment_id}${section.id}`,
            true
          );
          setShowAssessmentInfo(false);
        };
      } catch (error) {
        if (error.name === 'NotAllowedError' && !hasUserInteracted) {
          alert("Please click anywhere on the page to enable audio playback.");
        } else {
          console.error("Error playing audio:", error);
          localStorage.setItem(
            `ShowInfo${data.student_assessment_id}${section.id}`,
            true
          );
          setShowAssessmentInfo(false);
        }
      }
    }
    else{
      console.log("audio loaded");
      SectionaudioRef.current.addEventListener("loadeddata", playaudio)
    }
  };
  useEffect(() => {
    if (data?.status === assignmentStatus.INPROGRESS || assessmentStarted) {
      setTimeout(() => {
        playaudio();
      }, 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, assessmentStarted, hasUserInteracted]);
  return (
    <>
      <div
        key={section.id}
        className={`d-flex flex-column ${
          isMobileView ? "sm-Speak-Quizbody" : "Speak-Quizbody"
        }`}
      >
        <div className="d-flex flex-column main-content container speak-content-width">
        <div className="flex-container">
          <h3 class="custom-heading">{section.instruction_title}</h3>
        </div>
        <p class="regular-text py-3">{section.instruction_subtitle}</p>
        <div class="photo-description justify-content-center border  overflow-auto custom_scroll">
          <div
            spellcheck="false"
            data-gramm="false"
            dangerouslySetInnerHTML={{
              __html: `${section.instruction
                ?.replace(/\[\[.*?\]\]\.\s*/g, "")
                .replace(/\[\[.*?\]\]\s*/g, "")}`,
            }}
          />
        </div>
        <div>
          <audio
            ref={SectionaudioRef}
            src={section.instruct_audio ? section.instruct_audio : ""}
            playsInline={true}
          />
        </div>
        </div>
        {!isSPEAKABC && (
        <div className={isMobileView ? ("col-12 sm-footer-bottom") : "col-10 sm-footer-bottom"}>
          <SpeakFooter />
        </div>
        )}
      </div>
    </>
  );
};

export default SpeakQuestionInfo;
